import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_113_10689)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_113_10689",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_113_10689)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3.3077 20.0034C2.8757 20.0034 2.4997 19.8435 2.1797 19.5236C1.85987 19.2038 1.69995 18.8279 1.69995 18.3959V7.3574H2.99995V18.3959C2.99995 18.4856 3.02878 18.5592 3.08645 18.6169C3.14412 18.6746 3.21787 18.7034 3.3077 18.7034H18.7V20.0034H3.3077ZM6.4077 16.9034C5.97554 16.9034 5.59954 16.7435 5.2797 16.4236C4.95987 16.1038 4.79995 15.7279 4.79995 15.2959V4.72665C4.79995 4.28298 4.95987 3.90406 5.2797 3.5899C5.59954 3.2759 5.97554 3.1189 6.4077 3.1189H10.6135L13.0135 5.5189H19.4922C19.9359 5.5189 20.3148 5.6759 20.629 5.9899C20.943 6.30406 21.1 6.68298 21.1 7.12665V15.2959C21.1 15.7279 20.943 16.1038 20.629 16.4236C20.3148 16.7435 19.9359 16.9034 19.4922 16.9034H6.4077ZM6.4077 15.6036H19.4922C19.582 15.6036 19.6558 15.5747 19.7135 15.5169C19.7711 15.4592 19.8 15.3856 19.8 15.2959V7.12665C19.8 7.03681 19.7711 6.96306 19.7135 6.9054C19.6558 6.84773 19.582 6.8189 19.4922 6.8189H12.5L10.1 4.4189H6.4077C6.31787 4.4189 6.24412 4.44773 6.18645 4.5054C6.12879 4.56306 6.09995 4.63681 6.09995 4.72665V15.2959C6.09995 15.3856 6.12879 15.4592 6.18645 15.5169C6.24412 15.5747 6.31787 15.6036 6.4077 15.6036Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_113_10689",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgProject;
